module.exports = __webpack_public_path__ + "static/img/product_banner_10_zh.9aa44ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_10_zh.png
// module id = itwm
// module chunks = 34